import { render, staticRenderFns } from "./WatchlistButton.vue?vue&type=template&id=3f4951fe&scoped=true"
import script from "./WatchlistButton.vue?vue&type=script&lang=js"
export * from "./WatchlistButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4951fe",
  null
  
)

export default component.exports